<template>
    <h4>Register</h4>

    <form data-ajax-form validate>
        <input type="hidden" name="action" value="register" />
        <input type="hidden" name="nonce"  :value="nonce" />

        <div data-form-msg></div>
        <fieldset>
            <legend>User Info</legend>

            <div class="inputControl half">
                <label for="firstName">First Name: <mark>*</mark></label>
                <input type="text" id="firstName" name="firstName" placeholder="First Name" required pattern="([a-zA-Z ,.'-])\w+" />
            </div>

            <div class="inputControl half last">
                <label for="lastName">LastName: <mark>*</mark></label>
                <input type="text" id="lastName" name="lastName" placeholder="Last Name" required pattern="([a-zA-Z ,.'-])\w+"/>
            </div>

            <div class="inputControl">
                <label for="email">Email: <mark>*</mark></label>
                <input type="text" id="email" name="email" placeholder="john.doe@tld.com" required />
            </div>

            <PasswordFields field1Classes="half" field2Classes="half last" />

            <fieldset>
                <legend>Recaptcha</legend>
                <div style="float:right;" class="g-recaptcha" :data-sitekey="siteKey"></div>
            </fieldset>
        
            <fieldset class="alignRight">
                <legend>Login</legend>
                <button type="submit" class="btn btn-primary btn-large" data-submit-btn>Login</button>
            </fieldset>

        </fieldset>
    </form>
</template>

<script>
import { mapState }    from 'pinia';
import { globalStore } from "../stores/global.js";
import { registerStore }  from "../stores/register.js";

import PasswordFields from "../forms/PasswordFields.vue";

export default {
    name: "LoginForm",
    components: {
        PasswordFields
    },
    props: {
        nonce: {
            type: String,
            required: true
        },
        siteKey: {
            type: String,
            required: true
        }
    },
    mounted() {},
    methods: {},
    computed: {
        ...mapState(registerStore, {
            nonce: store => store.nonces.register
        }),
        ...mapState(globalStore, {
            isUserAuthenticated: store => store.isUserAuthenticated,
            siteKey: store => store.siteKey
        })
    },
};
</script>

<style>
</style>
